import React, { useState } from "react";
import { light_logo, light_logo2 } from "../assets";

const ContactUs = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [topic, setTopic] = useState("");
  const [msg, setMsg] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    topic: "",
    msg: "",
  });

  const handleMessage = async (e) => {
    e.preventDefault();
  };
  return (
    <section className="lg:min-h-[670px] md:min-h-[780px] sm:min-h-[515px] text-whiteee lg:px-2 md:px-4 sm:px-4">
      <div className="max-w-[1280px] mx-auto lg:px-2 md:px-4 sm:px-4 lg:py-16 md:py-14 sm:py-12">
        <div className="flex justify-center items-center mb-12">
          <h2 className="lg:text-5xl md:text-3xl sm:text-3xl text-center lg:px-0 md:px-0 sm:px-4  font-extrabold tracking-tighter text-golden">
            Contact Us
          </h2>
        </div>
        <div className="flex justify-between lg:flex-row sm:flex-col  lg:gap-10 sm:gap-6">
          {/* SEND MESSAGE */}
          <div className="font-sora  max-w-[560px] w-full mx-auto">
            <p className="text-2xl mb-4">Contact From</p>
            <p className="text-[14px]">
              Please fill in the form below and a dedicated member of our team
              will be in touch within 24 hours
            </p>

            <form className="mt-8" onSubmit={handleMessage}>
              <div className="flex flex-col gap-4">
                <div className="relative">
                  <input
                    id="name"
                    name="name"
                    value={formData.name}
                    placeholder="Your full name"
                    required
                    autoComplete="off"
                    className="form-control text-[14px] p-3 border border-golden rounded-md w-full  text-golden"
                    type="search"
                    onChange={(e) =>
                      setFormData({ ...formData, name: e.target.value })
                    }
                  />
                  <div className="absolute right-2 top-1/2 transform -translate-y-1/2">
                    <i className="i-search text-muted text-gray-500"></i>
                  </div>
                </div>
                <div className="relative">
                  <input
                    id="email"
                    name="email"
                    value={formData.email}
                    placeholder="example@email.com"
                    required
                    autoComplete="off"
                    className="form-control text-[14px] p-3 border border-golden rounded-md w-full  text-golden"
                    type="search"
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                  />
                  <div className="absolute right-2 top-1/2 transform -translate-y-1/2">
                    <i className="i-search text-muted text-gray-500"></i>
                  </div>
                </div>

                <div className="form-group">
                  <select
                    id="topic"
                    name="topic"
                    value={formData.topic}
                    required
                    className="form-control text-[14px] p-3 border border-golden rounded-md w-full text-golden"
                    onChange={(e) =>
                      setFormData({ ...formData, topic: e.target.value })
                    }
                  >
                    <option disabled value="" className="text-[14px]">
                      Select Topic
                    </option>
                    <option value="General Enquiries" className="text-[14px]">
                      General Enquiries
                    </option>
                  </select>
                </div>

                <div className="relative">
                  <textarea
                    id="msg"
                    name="msg"
                    value={formData.msg}
                    placeholder="Your message"
                    required
                    autoComplete="off"
                    className="form-control text-[14px] min-h-[160px] p-3 border border-golden rounded-md w-full  text-golden"
                    type="search"
                    onChange={(e) =>
                      setFormData({ ...formData, msg: e.target.value })
                    }
                  />
                  <div className="absolute right-2 top-1/2 transform -translate-y-1/2">
                    <i className="i-search text-muted text-gray-500"></i>
                  </div>
                </div>

                <p className="text-[12px] text-golden">
                  * Make sure all the fields are filled
                </p>

                <input
                  type="submit"
                  name=""
                  value="Send Message"
                  className={
                    name !== "" && email !== "" && topic !== "" && msg !== ""
                      ? " py-3 rounded-xl bg-goldendark text-white lg:w-4/12 sm:w-full "
                      : "py-3 bg-golden text-gray-400 rounded-xl lg:w-4/12 sm:w-full"
                  }
                />
              </div>
            </form>
          </div>
          {/* MAP AND CALL */}
          <div className="font-sora  shadow-xl rounded-xl bg_sec max-w-[560px] w-full mx-auto">
            <div className="p-8 bg-[#292929] rounded-xl flex items-center justify-center">
              <img
                src="https://wristlink.app/static/media/wwlogo.8d734fb8035e44e1cf37.png"
                className="h-[200px] w-[300px]"
              />
            </div>

            <div className="p-10 rounded-bl-xl rounded-br-xl ">
              <p className="lg:text-[18px] sm:text-[16px] text-golden font-bold">
                WristLink HQ
              </p>

              <div className="  pb-6 pt-3 my-2 text-[14px] font-mr">
                <p>Dubai, UAE</p>
                <p>+971 50 22 77747</p>
              </div>

              <div className=" h-[1px] bg-gradient-to-r from-primary  via-golden to-primary"></div>

              <div className="grid lg:grid-cols-2 sm:grid-cols-1 gap-4 mt-6">
                <div>
                  <p className="text-xs">Write us an email</p>
                  <a
                    href="support@marmaragold.ae"
                    className="lg:text-[18px] sm:text-xl font-bold font-mr "
                  >
                    info@wristlink.app
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
